import type { ScreenModule } from "../../../app/screen-module";
import { WorkspaceVisualPage } from "../WorkspacePages";

export default {
	id: "end-user.workspace-visual",
	path: "/app/workspace/:projectId",
	area: "end-user",
	label: "ワークスペース Visual",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: WorkspaceVisualPage,
} satisfies ScreenModule;
